export default class MetaData {
    constructor(metadata) {
        this.filter_count = metadata === null || metadata === void 0 ? void 0 : metadata.filter_count;
        this.total_count = metadata === null || metadata === void 0 ? void 0 : metadata.total_count;
    }
}
